'use client';

import { c as _c } from "react/compiler-runtime";
import { Picture } from '@petsmart-ui/sparky';
import { useMemo } from 'react';
import type { PictureProps } from './type';
import { generateOptimizedPictureProps } from './utils';
export function ResponsivePicture(t0) {
  const $ = _c(45);
  let alt;
  let className;
  let imageComponentProps;
  let onMouseEnter;
  let onMouseLeave;
  let onMouseMove;
  let other;
  let qlt;
  let size;
  let sizes;
  let src;
  let t1;
  if ($[0] !== t0) {
    ({
      src,
      alt,
      priority: t1,
      size,
      sizes,
      onMouseEnter,
      onMouseMove,
      onMouseLeave,
      className,
      qlt,
      imageComponentProps,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = alt;
    $[2] = className;
    $[3] = imageComponentProps;
    $[4] = onMouseEnter;
    $[5] = onMouseLeave;
    $[6] = onMouseMove;
    $[7] = other;
    $[8] = qlt;
    $[9] = size;
    $[10] = sizes;
    $[11] = src;
    $[12] = t1;
  } else {
    alt = $[1];
    className = $[2];
    imageComponentProps = $[3];
    onMouseEnter = $[4];
    onMouseLeave = $[5];
    onMouseMove = $[6];
    other = $[7];
    qlt = $[8];
    size = $[9];
    sizes = $[10];
    src = $[11];
    t1 = $[12];
  }
  const priority = t1 === undefined ? "lazy" : t1;
  let t2;
  if ($[13] !== sizes) {
    t2 = sizes?.sort(_temp);
    $[13] = sizes;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  const sortedSizes = t2;
  let t3;
  if ($[15] !== size || $[16] !== sortedSizes) {
    t3 = sortedSizes?.length ? sortedSizes : [size || {
      width: 400,
      height: 400
    }];
    $[15] = size;
    $[16] = sortedSizes;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== qlt || $[19] !== src || $[20] !== t3) {
    t4 = generateOptimizedPictureProps(src, t3, qlt);
    $[18] = qlt;
    $[19] = src;
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  const {
    imgSrc,
    pictureItems
  } = t4;
  let t5;
  if ($[22] !== imgSrc || $[23] !== priority) {
    t5 = priority === "eager" && <link rel="preload" key={imgSrc} href={imgSrc} as="image" />;
    $[22] = imgSrc;
    $[23] = priority;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      width: "auto",
      height: "auto",
      display: "block"
    };
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== size) {
    t7 = size ?? {};
    $[26] = size;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== imageComponentProps || $[29] !== priority || $[30] !== t7) {
    t8 = {
      loading: priority,
      sizes: "100vw",
      style: t7,
      ...imageComponentProps
    };
    $[28] = imageComponentProps;
    $[29] = priority;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== alt || $[33] !== className || $[34] !== imgSrc || $[35] !== onMouseEnter || $[36] !== onMouseLeave || $[37] !== onMouseMove || $[38] !== other || $[39] !== pictureItems || $[40] !== t8) {
    t9 = <Picture className={className} style={t6} imgSrc={imgSrc} imgAlt={alt} items={pictureItems} imageComponentProps={t8} onMouseEnter={onMouseEnter} onMouseMove={onMouseMove} onMouseLeave={onMouseLeave} data-testid="responsive-picture" {...other} />;
    $[32] = alt;
    $[33] = className;
    $[34] = imgSrc;
    $[35] = onMouseEnter;
    $[36] = onMouseLeave;
    $[37] = onMouseMove;
    $[38] = other;
    $[39] = pictureItems;
    $[40] = t8;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  let t10;
  if ($[42] !== t5 || $[43] !== t9) {
    t10 = <>{t5}{t9}</>;
    $[42] = t5;
    $[43] = t9;
    $[44] = t10;
  } else {
    t10 = $[44];
  }
  return t10;
}
function _temp(a, b) {
  return b.width - a.width;
}